import React from 'react';

const Footer = () => {
  return (
    <footer className="mt-24 border-t border-red-900/30 pt-12">
      <div className="container mx-auto px-6">
        <div className="text-center text-gray-400">
          <p className="mb-2">© 2026 Virtual Red Air. All rights reserved.</p>
          <p className="text-sm">Advancing Synthetic Training Ecosystems for Modern Defence</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
